export default {
  'Navbar.page1.test': `Coucou`,

  'Team.title': `Équipe`,
  'Team.result': `Résultat`,
  'Team.result.atk': `Attaque : {value}`,
  'Characters.title': `Héros`,
  'Characters.configure': `Configurer`,
  'Characters.close': `Fermer`,
  'Characters.add': `Ajouter`,

  'Stats.hero.atk': `Att : { value }`,
  'Stats.hero.hp': `Vie : { value }`,
  'Stats.hero.def': `Déf : { value }`,
  'Stats.hero.ctkRate': `Chance coup critique : { value }%`,
  'Stats.hero.ctkDam': `Dégats Critiques :  +{ value }%`,
  'Stats.hero.aps': `Att par sec : { value }`,
  'Stats.hero.atkRange': `Portée Att : { value }`,
  'Stats.hero.moveSpeed': `Vitesse déplacement : { value }`,
  'Stats.hero.effectResistance': `Résistance effets : { value }%`,

  'Stats.hero.frenzy': `Chance frénésie : { value }%`,
  'Stats.hero.dodge': `Chance Esquive : { value }%`,
  'Stats.hero.stunChance': `Chance Etourdis : { value }%`,
  'Stats.hero.stunTime': `Durée étourdis : { value }%`,
  'Stats.hero.atkAoe': `Zone de dégats : { value }%`,
  'Stats.hero.ultimateAtk': `Pouvoirs Ultime Att. : { value }%`,
  'Stats.hero.knightShield': `Vie boucliers : { value }%`,
  'Stats.hero.bonusGold': `Bonus Or : { value }%`,

  'Stats.hero.freezeChance': `Chance de Geler : { value }%`,
  'Stats.hero.freezeTime': `Durée Gel : { value }%`,
  'Stats.hero.freezeExplosionDmg': `Dégats d'explosion du Gel : { value }%`,
  'Stats.hero.burnChance': `Chance Embrasement : { value }%`,
  'Stats.hero.burnTime': `Temps Combustion : { value }%`,
  'Stats.hero.burnDmg': `Dégâts Brûlure : { value }%`,
  'Stats.hero.poisonChance': `Chance Poison : { value }%`,
  'Stats.hero.poisonTime': `Durée Poison : { value }%`,
  'Stats.hero.poisonDmg': `Dégâts Poison : { value }%`,

  'hero.akwa': `Akwa`,
  'hero.alda': `Alda`,
  'hero.angelica': `Angelica`,
  'hero.arcana': `Arcana`,
  'hero.atlantus': `Atlantus`,
  'hero.bat': `Bat`,
  'hero.big-eye': `Big Eye`,
  'hero.black-beard': `Barbe Noir`,
  'hero.blue-fish': `Blue Fish`,
  'hero.bugonaut-archer': `Bugonaut Archer`,
  'hero.bugonaut-fighter': `Bugonaut Fighter`,
  'hero.bugonaut-giant': `Bugonaut Giant`,
  'hero.bugonaut-spear': `Bugonaut Spear`,
  'hero.chaos': `Chaos`,
  'hero.circe': `Circe`,
  'hero.clawdette': `Clawdette`,
  'hero.dark-hunter': `Chasseur des Ténèbres`,
  'hero.dark-knight': `Ash`,
  'hero.dark-wolf': `Lycan`,
  'hero.fire-monk': `Fire Monk`,
  'hero.frost-queen': `Frost Queen`,
  'hero.furiosa': `Furiosa`,
  'hero.gladiator': `Spartacus`,
  'hero.goddess': `Goddess`,
  'hero.gold-knight': `Chevalier d'Or`,
  'hero.green-faery': `GreenFaery`,
  'hero.groovine': `Groovine`,
  'hero.hikari': `Hikari`,
  'hero.hooky': `Hooky`,
  'hero.ice-cube': `Ice Cube`,
  'hero.ice-knight': `Ice Knight`,
  'hero.jasmine': `Jasmine`,
  'hero.joan-of-arc': `Jeanne`,
  'hero.kage': `Kage`,
  'hero.kasai': `Kasai`,
  'hero.kasumi': `Kasumi`,
  'hero.krouki': `Monki Krouki`,
  'hero.krunk': `Krunk`,
  'hero.leaf-blade': `Leaf Blade`,
  'hero.light-knight': `Chevalier de Lumière`,
  'hero.luka': `Luka`,
  'hero.magmus': `Magmus`,
  'hero.mecha-valken': `Mecha Valken`,
  'hero.merlinus': `Merlinus`,
  'hero.misty': `Misty`,
  'hero.mizu': `Mizu`,
  'hero.monki-king': `Monki King`,
  'hero.monki-mortar': `Monki Mortar`,
  'hero.monki-robot': `Monki Roboti`,
  'hero.musashi': `Musashi`,
  'hero.namida': `Namida`,
  'hero.natura': `Natura`,
  'hero.necromancer': `Necromancien`,
  'hero.neko': `Neko`,
  'hero.oceana': `Océana`,
  'hero.one-eye': `One Eye`,
  'hero.onyx': `Onyx`,
  'hero.ornok': `Ornok`,
  'hero.paladin': `Paladin`,
  'hero.petunia': `Petunia`,
  'hero.pinky': `Pinky`,
  'hero.pirato': `Pirato`,
  'hero.pumpking': `PumpKing`,
  'hero.ra': `Râ`,
  'hero.robin-hood': `Robin`,
  'hero.rufus': `Rufus`,
  'hero.scud': `Scud`,
  'hero.ser-shu': `Ser Shû`,
  'hero.siegfried': `Siegfried`,
  'hero.skeleton-giant': `Skeleton Giant`,
  'hero.skeleton-infantry': `Skeleton Infantry`,
  'hero.skeleton-ranger': `Skeleton Ranger`,
  'hero.snowman': `Snowman`,
  'hero.sorrow': `Sorrow`,
  'hero.spark': `Spark`,
  'hero.spike': `Spike`,
  'hero.sprout': `Sprout`,
  'hero.spyro': `Spyro`,
  'hero.swift': `Swift`,
  'hero.tellus': `Golem Earth`,
  'hero.tesla': `Tesla`,
  'hero.thor': `Thor`,
  'hero.thorn': `Thorn`,
  'hero.tiny-dragon': `Tiny Dragon`,
  'hero.torch': `Torche`,
  'hero.valkyrie': `Valkyrie`,
  'hero.vlad': `Vlad`,
  'hero.voodoo-archer': `Voodoo Archer`,
  'hero.voodoo-dagger': `Voodoo Dagger`,
  'hero.voodoo-spear': `Voodoo Spear`,
  'hero.vulcan-archer': `Vulcan Archer`,
  'hero.vulcan-fighter': `Vulcan Fighter`,
  'hero.vulcan-hammer': `Vulcan Hammer`,
  'hero.wolfie': `Wolfie`,
  'hero.xak': `Xak`,
}
